import "./OurStory.module.css";
import DropshippingHero from "@/reusable_sections/Header";
import UnsereGeschichte from "./sections/UnsereGeschichte";
import OurAuthority from "./sections/OurAuthority";
import BrandFooter from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <DropshippingHero />
      <UnsereGeschichte />
      <OurAuthority />
      <BrandFooter />
    </div>;
}